module.exports = __webpack_public_path__ + "static/media/yasmine.5c8f4490.JPG";